export const IdentificationTypes = {
    EGN: 4641,
    Foreigner: 4642
}

export const GenderTypes = {
    Male: 4644,
    Female: 4645
}

export const NIPData = {
    Id: 136
}

export const ComponentSize = {
    Small: 'col-md-4',
    Medium: 'col-6',
    Large: 'col-12'
}

export const Countries = {
    BG: 5251
}

export const Cities = {
    Sofia: 2643,
    ForeignCity: 5449
}

export const DropdownType = {
    Nomenclature: 1,
    Register: 2,
    DynamicRegister: 3
}

export const HttpStatusCode = {
    BadRequest: 400,
    NotAuthorized: 401,
    NotFound: 404,
    ServerError: 500
}

export const DynamicRegister = {
    Mentors: 1,
    Events: 54,
    Participants: 55,
    Lecturers: 56,
    Employees: 57
}

export const OrderStatus = {
    Open: 5323
}

export const InputType = {
    Text: 'text',
    TextArea: 'textarea',
    Number: 'number'
}

export const NumberType = {
    Int: 'int',
    Decimal: 'decimal'
}

export const Culture = {
    BG: 'bg',
    EN: 'en'
}

export const ComponentType = {
    FileUpload: 'FileUpload',
    Person: 'Person',
    Address: 'Address'
}

export const SystemDynamicRegisterDropdown = {
    SingleEventsNameDropdownId: 1242, // Id �� RegisterFields �� ���� �� SystemRegister, ����� �� �������� �� single dropdown �� �������
    MultipleEventsNameDropdownId: 1243 // Id �� RegisterFields �� ���� �� SystemRegister, ����� �� �������� �� multiple dropdown �� �������
}

export const EmployeeDynamicRegisterDropdown = {
    EmployeeNameDropdownId: 2244 // Id �� RegisterFields �� ���� �� Employee, ����� �� �������� �� ��� �� ���������
}

// Тип на формуляр - n.Nomenclature - Id = 6711
export const FormType = {
    RequestToParticipate: 6712, // Id from n.Nomenclature
    CollectionOfData: 6713,
    ProposalForThematicAreas: 6714
}

export const LectorsDocumentTypes = {
    CV: 6748,
    File: 6749
}

export const EvaluationCriteriaType = {
    Admissibility: 1,
    Evaluation: 2
}

export const PersonSearchType = {
    Person: 1,
    Lector: 2,
    Participant: 3
}

export const KendoGridPageSize = {
    All: 'All'
}

export const TaskStatus = {
    New: 2,
    Started: 3,
    Finished: 4,
    NotAccepted: 5,
    Done: 7
}

export const CoordinationStatus = {
    new: 'new',
    started: 'started',
    completed: 'completed',
    canceled: 'canceled',
}

export const SigningStatus = {
    new: 'New',
    started: 'Started',
    completed: 'Completed',
    canceled: 'Canceled',
}

export const DocumentsRelationRegisterType = {
    Static: 'Статични регистри',
    Dynamic: 'Динамични регистри',
    Finance: 'Финанси',
    Task: 'Задачи',
}

export const NomenclatureParentBySort = {
    EventRegister: -999,
    LegalArea: 1000,
    EventType: 2000,
    EventActivity: 4000,
    FundingType: 5000,
    EventForm: 6000,
    LanguageOfProficiency: 9500,
    TaskPriority: 10000,
    TaskCategory: 10100,
    LectorStatus: 12000,
    Directorate: 13000,
    PersonIdentificationType: 14000,
    GenderType: 15000,
    LanguageFluency: 16000,
    ActivityType: 25000,
    PositionStatistic: 29000,
    EducationDegree: 35000,
    Position: 36000,
    Salutation: 37000,
    TitleDegree: 40000,
    Menu: 20000,
    Countries: 21000,
    AbsenceType: 51000,
    FormType: 43000,
    AccommodationPlaceType: 18000,
    AccommodationPlaceCategory: 19000,
    Department: 41000,
    InstitutionType: 32000,
    InstitutionLevel: 33000,
    ReasonForJoining: 41000,
    ReasonForRelease: 42000,
    ProjectFinancing: 3000000,
    PublicOrderStatus: 22000,
    PublicOrderType: 23000,
    AssessmentType: 24000,
    ObjectType: 26000,
    Currency: 27000,
    PublicOrderDocumentType: 28000,
    EventDirection: 45000,
    ParticipationStatus: 49000,
}

export const Claim = {
    AspNetRoleAdministration: 'AspNetRoleAdministration',
    AspNetUserAdministration: 'AspNetUserAdministration',
    ApplicationSettings: 'ApplicationSettings',
    AuxiliaryRegisterFieldCode: 'AuxiliaryRegisterFieldCode',
    Claims: 'Claims',
    DynamicRegister: 'DynamicRegister',
    Email: 'Email',
    Evaluation: 'Evaluation',
    EvaluationCriteria: 'EvaluationCriteria',
    Event: 'Event',
    EventAgenda: 'EventAgenda',
    EventBudget: 'EventBudget',
    EventCosts: 'EventCosts',
    EventDetails: 'EventDetails',
    FormFieldCode: 'FormFieldCode',
    EventFormManagement: 'EventFormManagement',
    EventParticipantManagement: 'EventParticipantManagement',
    EventReport: 'EventReport',
    EventSubscriptions: 'EventSubscriptions',
    FormSurvey: 'FormSurvey',
    FormSurveyTemplate: 'FormSurveyTemplate',
    FormSurveyEntity: 'FormSurveyEntity',
    FormSecurity: 'FormSecurity',
    HallsSchedules: 'HallsSchedules',
    Lecturer: 'Lecturer',
    Mentor: 'Mentor',
    NijEmployee: 'NijEmployee',
    NotificationSubscriptionWithActivationOfParticipationRequest: 'NotificationSubscriptionWithActivationOfParticipationRequest',
    OrganizationalCalendar: 'OrganizationalCalendar',
    OrganizationalModel: 'OrganizationalModel',
    Participant: 'Participant',
    Person: 'Person',
    RankingCriteria: 'RankingCriteria',
    Tariff: 'Tariff',
    TempRanking: 'TempRanking',
    ReleaseInfo: 'ReleaseInfo',
    RegisterFieldCode: 'RegisterFieldCode',
    CertificateAdministration: 'CertificateAdministration',
    Certificates: 'Certificates',
    Localization: 'Localization',
    LecturersElRegister: 'LecturersElRegister',
    UpcomingEvent: 'UpcomingEvent',
    UninformedParticipants: 'UninformedParticipants',
    AuxiliaryRegister: 'AuxiliaryRegister',
    Help: 'Help',
    UpcomingEventsPanelDescription: 'UpcomingEventsPanelDescription',
    TasksAdministration: 'TasksAdministration',
    CoordinationsAdministration: 'CoordinationsAdministration',
    ClaimsAdministration: 'ClaimsAdministration',
    Company: 'Company',
    DeletedRecords: 'DeletedRecords',
    DataReferences: 'DataReferences',
    InstitutionsRegister: 'InstitutionsRegister',
    ParticipantWithPerson: 'ParticipantWithPerson',
    OrganizersRegister: 'OrganizersRegister',
    VenuesRegister: 'VenuesRegister',
    AccommodationPlacesRegister: 'AccommodationPlacesRegister',
    ProjectsRegister: 'ProjectsRegister',
    PublicOrdersRegister: 'PublicOrdersRegister',
    ActivitiesRegister: 'ActivitiesRegister',
    ThematicAreasRegister: 'ThematicAreasRegister',
    EventThemesRegister: 'EventThemesRegister',
    NijPositionsRegister: 'NijPositionsRegister',
    ContractsRegister: 'ContractsRegister',
    OrganizationalModelsRegister: 'OrganizationalModelsRegister',
    RankingCriteriaRegister: 'RankingCriteriaRegister',
    QESLocalServer: 'QESLocalServer',
    SigningAdministration: 'SigningAdministration',
    SigningProcedureFiling: 'SigningProcedureFiling',
}

export const Crud = {
    Create: 'CREATE',
    Read: 'READ',
    Update: 'UPDATE',
    Delete: 'DELETE'
}

export const EventClaims = {
    Event: 'EVENT',
    RankingCriteria: 'RANKINGCRITERIA',
    TempRanking: 'TEMPRANKING',
    EventAgenda: 'EVENTAGENDA',
    EventBudget: 'EVENTBUDGET',
    EventCosts: 'EVENTCOSTS',
    EventFormManagement: 'EVENTFORMMANAGEMENT',
    EventParticipantManagement: 'EVENTPARTICIPANTMANAGEMENT',
    EventReport: 'EVENTREPORT',
    EventSubscriptions: 'EVENTSUBSCRIPTIONS',
    OrganizationalCalendar: 'ORGANIZATIONALCALENDAR',
    UninformedParticipants: 'UNINFORMEDPARTICIPANTS'
}

// All records from A.Claim data table. Used for claims authorization. See store.js, claims object
export const ClaimsNormalized = {
    AnnualCatalog: 'ANNUALCATALOG',
    AnnualCatalogProject: 'ANNUALCATALOGPROJECT',
    AspNetRoleAdministration: 'ASPNETROLEADMINISTRATION',
    AspNetUserAdministration: 'ASPNETUSERADMINISTRATION',
    ApplicationSettings: 'APPLICATIONSETTINGS',
    AuxiliaryRegisterFieldCode: 'AUXILIARYREGISTERFIELDCODE',
    Audit: 'AUDIT',
    Calendar: 'CALENDAR',
    Claims: 'CLAIMS',
    Documents: 'DOCUMENTS',
    DynamicRegister: 'DYNAMICREGISTER',
    Email: 'EMAIL',
    Evaluation: 'EVALUATION',
    EvaluationCriteria: 'EVALUATIONCRITERIA',
    Event: 'EVENT',
    EventAgenda: 'EVENTAGENDA',
    EventBudget: 'EVENTBUDGET',
    EventCosts: 'EVENTCOSTS',
    EventDetails: 'EVENTDETAILS',
    EventFormManagement: 'EVENTFORMMANAGEMENT',
    EventParticipantManagement: 'EVENTPARTICIPANTMANAGEMENT',
    EventReport: 'EVENTREPORT',
    EventSubscriptions: 'EVENTSUBSCRIPTIONS',
    ExternalServices: 'EXTERNALSERVICES',
    FinancialControl: 'FINANCIALCONTROL',
    FormFieldCode: 'FORMFIELDCODE',
    FormSurvey: 'FORMSURVEY',
    FormSurveyEntity: 'FORMSURVEYENTITY',
    FormSurveyTemplate: 'FORMSURVEYTEMPLATE',
    FormSecurity: 'FORMSECURITY',
    Forum: 'FORUM',
    HallsSchedules: 'HALLSSCHEDULES',
    Lecturer: 'LECTURER',
    Mentor: 'MENTOR',
    NijData: 'NIJDATA',
    NijEmployee: 'NIJEMPLOYEE',
    Nomenclature: 'NOMENCLATURE',
    NomenclatureTypes: 'NOMENCLATURETYPES',
    Notifications: 'NOTIFICATIONS',
    NotificationSubscriptionWithActivationOfParticipationRequest: 'NOTIFICATIONSUBSCRIPTIONWITHACTIVATIONOFPARTICIPATIONREQUEST',
    OrganizationalCalendar: 'ORGANIZATIONALCALENDAR',
    OrganizationalModel: 'ORGANIZATIONALMODEL',
    Participant: 'PARTICIPANT',
    Person: 'PERSON',
    Presence: 'PRESENCE',
    Planning: 'PLANNING',
    RankingCriteria: 'RANKINGCRITERIA',
    Registers: 'REGISTERS',
    RegisterFieldCode: 'REGISTERFIELDCODE',
    Reports: 'REPORTS',
    ReportsData: 'REPORTSDATA',
    Tariff: 'TARIFF',
    Tasks: 'TASKS',
    TempRanking: 'TEMPRANKING',
    ReleaseInfo: 'RELEASEINFO',
    CertificateAdministration: 'CERTIFICATEADMINISTRATION',
    Certificates: 'CERTIFICATES',
    Localization: 'LOCALIZATION',
    LecturersElRegister: 'LECTURERSELREGISTER',
    UpcomingEvent: 'UPCOMINGEVENT',
    UninformedParticipants: 'UNINFORMEDPARTICIPANTS',
    AuxiliaryRegister: 'AUXILIARYREGISTER',
    Help: 'HELP',
    UpcomingEventsPanelDescription: 'UPCOMINGEVENTSPANELDESCRIPTION',
    TasksAdministration: 'TASKSADMINISTRATION',
    CoordinationsAdministration: 'COORDINATIONSADMINISTRATION',
    ClaimsAdministration: 'CLAIMSADMINISTRATION',
    Company: 'COMPANY',
    DeletedRecords: 'DELETEDRECORDS',
    DataReferences: 'DATAREFERENCES',
    InstitutionsRegister: 'INSTITUTIONSREGISTER',
    ParticipantWithPerson: 'PARTICIPANTWITHPERSON',
    OrganizersRegister: 'ORGANIZERSREGISTER',
    VenuesRegister: 'VENUESREGISTER',
    AccommodationPlacesRegister: 'ACCOMMODATIONPLACESREGISTER',
    ProjectsRegister: 'PROJECTSREGISTER',
    PublicOrdersRegister: 'PUBLICORDERSREGISTER',
    ActivitiesRegister: 'ACTIVITIESREGISTER',
    ThematicAreasRegister: 'THEMATICAREASREGISTER',
    EventThemesRegister: 'EVENTTHEMESREGISTER',
    NijPositionsRegister: 'NIJPOSITIONSREGISTER',
    ContractsRegister: 'CONTRACTSREGISTER',
    OrganizationalModelsRegister: 'ORGANIZATIONALMODELSREGISTER',
    RankingCriteriaRegister: 'RANKINGCRITERIAREGISTER',
    QESLocalServer: 'QESLOCALSERVER',
    SigningAdministration: 'SIGNINGADMINISTRATION',
    SigningProcedureFiling: 'SIGNINGPROCEDUREFILING',
}

export const FieldCodes = {
    EventName: 'Event_name',
    ThemeName: 'Event_name',
    EventNameEn: 'Event_nameEn',
    EventStartDate: 'Event_start',
    EventEndDate: 'Event_end',
    EventSubscriptionStartDate: 'Event_subscription_start',
    EventSubscriptionEndDate: 'Event_subscription_end',
    EventLocation: 'Event_location',
    EventAudience: 'Event_audience',
    ThematicArea: 'Thematic_area',
    Theme: 'Theme',
    EventMoodleCategory: 'EventMoodleCategory',
    EventDirectorate: 'Event_Directorate',
    LegalArea: 'Event_LegalArea',
    EventFundingType: 'Event_FundingType',
    EventNote: 'Event_Note',
    EventParticipantsCount: 'Event_Participants_count',
    EventDailyAllowanceFrom: 'Event_Daily_Allowance_From',
    EventDailyAllowanceTo: 'Event_Daily_Allowance_To',
    EventStayFrom: 'Event_Stay_From',
    EventStayTo: 'Event_Stay_To',
    EventActivityDirection: 'Event_Activity_Direction',
    EventSort: 'Event_Sort',
    EventStatus: 'Event_Status',
    EventExcludeFromReporting: 'Event_Exclude_From_Reporting',
    InstitutionOfEmployment: 'Institution_of_employment',
    EmployeePosition: 'Employee_position',
    EventVenue: 'Event_venue',
    EventProjectName: 'Event_Project_Name',
    EventOrganizerName: 'Event_Organizer_Name',
    EventDescription: 'Event_Description',
    EventExpectedResults: 'Event_Expected_Results',
    EventLearningGoals: 'Event_Learning_Goals',
    LastDayForBooking: 'Last_day_for_booking',
    EventMainActivity: 'Event_Main_Activity',
    EventAccommodationPlaceName: 'Event_AccommodationPlaceName',
    ParticipantIsMigrant: 'Participant_is_migrant',
    ParticipantIsForeigner: 'Participant_is_foreigner',
    ParticipantIsMemberOfAMinority: 'Participant_is_member_of_a_minority',
    ParticipantIsOfGypsyOrigin: 'Participant_is_of_gypsy_origin',
    ParticipantWithDisabilities: 'Participant_with_disabilities',
    ParticipantIsHomeless: 'Participant_is_homeless',
    ParticipantIsDisadvantaged: 'Participant_is_disadvantaged',
    ParticipantIsFromUnemployedHousehold: 'Participant_is_from_unemployed_household',
    ParticipantWithDependentChildren: 'Participant_with_dependent_children',
    ParticipantFromOneMemberHousehold: 'Participant_from_onemember_household"',
    TargetAudience: 'Target_audience',
    InstitutionOfEmploymentForm: 'Institution_of_employment_form',
    EventCode: 'Event_code',
    OrganizationalProposalForm: 'Organizational_Proposal_Form',
    ThemesProposalForm: 'Themes_Proposal_Form',
	AccommodationType: 'Event_Accommodation_Type',
	AccommodationAddress: 'Event_Accommodation_Address',
	EventForm: 'Event_Form',
    IdentificationType: 'Person_Identification_Type',
    IdentificationNumber: 'Person_Identification_Number',
    EventContactPersons: 'Event_ContactPersons'
}

export const FinancingTypes = {
    Budget: 6988,
    Nij: 5438,
    Partner: 21,
    Mixed: 22
}

export const RegisterFieldValueQueryFilter = {
    All: 'All',
    ShowInDescription: 'ShowInDescription',
    Active: 'Active'
}

export const RankingQuotaType = {
    AppellateRegion: 1,
    Institution: 2,
    Position: 3,
    ProfessionalOrientation: 4,
    FieldValue: 5
}

export const RankingConstraintType = {
    NumberOfParticipation: 1,
    NumberOfParticipationRequests: 2,
    NumberOfRefusalsToParticipate: 3,
    ConsentOfTheManager: 4,
    ParticipatesInOverlappingEvent: 5,
    OutsideTheTargetAudience: 6
}

export const FildType = {
    Bool: 1,
    Text: 2,
    Number: 3,
    Date: 4
}

export const DynamicLayoutPages = {
    Home: 1,
}

export const DynamicLayoutPageSize = {
    Min: 1,
    Max: 12,
}

export const AccommodationType = {
	WithourAccommodation: 35
}

export const PlanningLoadType = {
	Year: 'year',
	Dates: 'dates'
}

export const AuxiliaryRegisters = {
	Lecturers: 1,
	NijEmployees: 2,
	Mentors: 3,
	Organizers_Partners: 4,
	Venues: 5,
	AccommodationPlaces: 6,
	Projects: 7,
	PublicOrders: 8,
	Activities_Directions: 9,
	Thematic_areas: 10,
	Institutions_Organizations: 11,
	Administrative_positions: 12,
	External_suppliers_Contracts: 13
}

export const MimeType = {
    Pdf: 'application/pdf',
    Docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}
 export const FormSummaryParticipationStatus = {
    All: 0,
    GraduatedParticipants: 1,
}

export const FormSummarySurveyTypeEnum = {
    Anonymous: 0,
    NonAnonymous: 1,
    All: 2
}
